import { render, staticRenderFns } from "./GoWith.vue?vue&type=template&id=afb917aa&scoped=true&"
import script from "./GoWith.vue?vue&type=script&lang=js&"
export * from "./GoWith.vue?vue&type=script&lang=js&"
import style0 from "./GoWith.vue?vue&type=style&index=0&id=afb917aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb917aa",
  null
  
)

export default component.exports